import { useApp } from '@wap-client/core'

import { Column, Container, Row } from '@/components/base/gridview'
import Anchor from '@/components/base/anchor'
import Image from '@/components/base/image'
import Subscribe from '@/components/widgets/subscribe'
import SocialMedia from '@/components/widgets/social-media'

import FooterCopyright from './FooterCopyright'

import { FooterProps } from './types'
import SubscribeV2 from '../subscribe-v2'

const Footer: React.FunctionComponent<FooterProps> = ({
  footerNavigation,
  policyNavigation,
  logo,
}) => {
  const app = useApp()

  return (
    <footer className="footer-v2">
      <Container size="extended">
        <Row>
          <Column
            className="footer-v2-content"
            xs={{ size: 12 }}
            sm={{ size: 12 }}
            md={{ size: 12 }}
            lg={{ size: 12 }}
            xl={{ size: 12 }}
          >
            <figure className="footer-v2-content-logo">
              <a href="https://goturkiye.com">
                <Image {...logo} alt={app.page.title} height={50} />
              </a>
            </figure>

            {footerNavigation && footerNavigation?.length > 0 ? (
              <div className="footer-v2-content-menu">
                <ul>
                  {footerNavigation?.map((item, index) => (
                    <li key={index}>
                      <Anchor
                        href={item.href}
                        target={item.target}
                        dangerouslySetInnerHTML={{ __html: item.title }}
                      />
                    </li>
                  ))}
                </ul>
              </div>
            ) : null}

            <SocialMedia />

            <SubscribeV2 />
          </Column>
        </Row>
      </Container>

      <FooterCopyright policyNavigation={policyNavigation} />
    </footer>
  )
}

export default Footer
